import { Icon } from "materia"
import { getAccessibleTextColorForBackgroundColor, modifiers } from "ui-tools"
import s from "./Badge.module.scss"

type BadgeType = "default" | "score" | "scoreNoPoints" | "webGames"
type BadgeSize = "small" | "medium"

export const Badge = ({
  title,
  size = "medium",
  type = "default",
  backgroundColor,
}: {
  title: string
  size?: BadgeSize
  type?: BadgeType
  backgroundColor?: string
}) => {
  const colorStyle =
    backgroundColor === undefined
      ? undefined
      : {
          backgroundColor,
          color: getAccessibleTextColorForBackgroundColor(backgroundColor),
        }

  return (
    <div className={modifiers(s, "badge", type, size)} style={colorStyle}>
      <BadgeIcon type={type} />
      <div className={s.badge__text}>{title}</div>
    </div>
  )
}

const BadgeIcon = ({ type }: { type: BadgeType }) => {
  const icon = getBadgeIcon(type)
  if (icon === undefined) return

  return <Icon icon={icon} size="small" />
}

const getBadgeIcon = (type: BadgeType) => {
  switch (type) {
    case "webGames":
      return "Lightning"
  }
}
